import { render } from "./CancelConfirmation.vue?vue&type=template&id=05057463&scoped=true"
import script from "./CancelConfirmation.vue?vue&type=script&lang=js"
export * from "./CancelConfirmation.vue?vue&type=script&lang=js"

import "./CancelConfirmation.vue?vue&type=style&index=0&id=05057463&scoped=true&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05057463"]])

export default __exports__